import { render, staticRenderFns } from "./formgroup.vue?vue&type=template&id=5df2aa79&"
import script from "./formgroup.js?vue&type=script&lang=js&"
export * from "./formgroup.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5df2aa79')) {
      api.createRecord('5df2aa79', component.options)
    } else {
      api.reload('5df2aa79', component.options)
    }
    module.hot.accept("./formgroup.vue?vue&type=template&id=5df2aa79&", function () {
      api.rerender('5df2aa79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/common/formgroup.vue"
export default component.exports